<div style="padding-top:10px">
  <form novalidate [formGroup]="completionForm">
    <div class="flex-row flex-align-start flex-auto">
      <!-- Left Column -->
      <div class="flex-50">
        <div class="flex-column" style="padding-bottom:10px; padding-top: 20px;">
          <h6 class="card-title">Completion Attributes</h6>

          <!-- For each  Row  -->
          <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; padding-right: 20px;">
            <div class="form-group flex-50">
              <label>Formation</label>
              <input type="text" class="k-textbox form-control" readonly value="{{completionsObject?.TargetFormation}}">
            </div>
            @if (showStimProject) {
            <div class="form-group flex-50">
              <label>Clean Out Method</label>
              <kendo-dropdownlist class="form-control" [style.width.%]="90" formControlName="CleanOutMethod" [data]="dCleanoutMethod" [textField]="'Description'" [valueField]="'CleanoutMethodId'" [valuePrimitive]="true">
              </kendo-dropdownlist>
            </div>
            }
          </div>

          <!-- For each  Row  -->
          <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; padding-right: 20px;">
            <div class="form-group flex-50">
              <label>Derived Drilled Lateral Length</label>
              <input type="text" class="k-textbox form-control" readonly value="{{stagingData?.DrilledLateralLength | safeNumber:'1.0-0'}}">
            </div>
            <div class="form-group flex-50">
              <label>Frac Vendor</label>
              <kendo-dropdownlist class="form-control" [style.width.%]="90" formControlName="FracVendor" [data]="fracVendorData" [textField]="'VendorName'" [valueField]="'VendorName'" [valuePrimitive]="true">
              </kendo-dropdownlist>
            </div>
          </div>

          <!-- For each  Row  -->
          <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; padding-right: 20px;">
            @if (showPostStimProject) {
            <div class="form-group flex-50">
              <label>Artificial Lift Type</label>
              <kendo-dropdownlist class="form-control" [style.width.%]="90" formControlName="ArtificialLiftType" [data]="dArtificialLiftType" [textField]="'Description'" [valueField]="'ArtificialLiftTypeId'" [valuePrimitive]="true">
              </kendo-dropdownlist>
            </div>
            <div class="form-group flex-50">
              <label>Production Tubing Depth (TVD)</label>
              <input type="text" class="k-textbox form-control" readonly value="{{stagingData?.VerticalSection | safeNumber:'1.0-2'}}">
            </div>
            }
          </div>

          <!-- For each  Row  -->
          <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; padding-right: 20px;">
            @if (showStimProject) {
            <div class="form-group flex-50">
              <label>Completion Design</label>
              <input type="text" class="k-textbox form-control" readonly value="{{completionsObject?.CompletionDesign}}">
            </div>
            }
            <div class="form-group flex-50">
              <label>Water Type</label>
              <kendo-dropdownlist class="form-control" [style.width.%]="90" formControlName="WaterType" [data]="dWaterType" [textField]="'Description'" [valueField]="'WaterTypeId'" [valuePrimitive]="true">
              </kendo-dropdownlist>
            </div>
          </div>

          <!-- For each  Row  -->
          <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; padding-right: 20px;">
            <div class="form-group flex-50">
              <label>Wells in Frac Group (Includes Combined Frac Group)</label>
              <input type="number" class="k-textbox form-control" readonly value="{{stagingData?.WellsInFracGroup}}">
            </div>
            <div class="form-group flex-50">
              <label>Cost Basis</label>
              <kendo-dropdownlist class="form-control" [style.width.%]="90" formControlName="CostBasis" [data]="costBasisData" [textField]="'Value'" [valueField]="'Value'" [valuePrimitive]="true">
              </kendo-dropdownlist>
            </div>
          </div>

          <!-- For each  Row  -->
          <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; padding-right: 20px;">
            <div class="form-group flex-50">
              <label>Wells in Drill Group</label>
              <input type="number" class="k-textbox form-control" readonly value="{{stagingData?.WellsInDrillGroup}}">
            </div>
          </div>

          <!-- For each  Row  -->
          @if (showStimProject) {
          <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; padding-right: 20px;">
            <div class="form-group flex-50">
              <label>Frac Fleet</label>
              <input type="text" class="k-textbox form-control" readonly value="{{completionsObject?.FracFleet}}">
            </div>
            <div class="form-group flex-50">
              <label>DGB Substitution Percentage</label>
              <kendo-numerictextbox formControlName="DGBPercent" [style.width.%]="90" class="text-right form-control" [format]="'p1'" [step]=".01" [min]="0" [max]="1" [spinners]="false" [autoCorrect]="true">
              </kendo-numerictextbox>
            </div>
          </div>
          }

          <!-- For each  Row  -->
          <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; padding-right: 20px;">
            @if (showStimProject) {
            <div class="form-group flex-50">
              <label>Fuel Type &nbsp;&nbsp;</label>
              <kendo-dropdownlist class="form-control" [style.width.%]="90" formControlName="CompletionFuelType" [data]="dFuelType" [textField]="'Description'" [valueField]="'FuelTypeId'" [disabledControl]="true" [valuePrimitive]="true" (valueChange)="onFuelTypeChanged($event)">
              </kendo-dropdownlist>
            </div>
            <div class="form-group flex-50">
              <label>Fuel Type Override</label>
              <kendo-dropdownlist class="form-control" [style.width.%]="90" formControlName="CompletionFuelTypeOverride" [data]="dFuelType" [textField]="'Description'" [valueField]="'FuelTypeId'" [valuePrimitive]="true" (valueChange)="onFuelTypeChanged($event)">
              </kendo-dropdownlist>
            </div>
            }

          </div>

          <!-- For each different row  -->
          <div class="flex-row flex-100" style="padding-top:20px; padding-left:30px">
            <div class="flex-column flex-33">
              <div style="padding-top:28px;padding-right:20px" class="form-check flex-100">
                <input id="productionbhpgauges" class="form-check-input checkbox-parameters" formControlName="IsProductionBHPGauges" type="checkbox">
                <label class="form-check-label" for="productionbhpgauges">Production BHP Gauges</label>
              </div>

              <div style="padding-top:28px;padding-right:20px" class=" form-check flex-100">
                <input id="rentalesppump" class="form-check-input checkbox-parameters" formControlName="IsRentalESPPump" type="checkbox">
                <label class="form-check-label" for="rentalesppump">Rental ESP Pump</label>
              </div>
            </div>

            <div class="flex-column flex-33">
              <div style="padding-top:28px;padding-right:20px" class="form-check  flex-100">
                <input id="dfittest" class="form-check-input checkbox-parameters" formControlName="DFITTest" type="checkbox">
                <label class="form-check-label" for="dfittest">DFIT Test</label>
              </div>

              <div style="padding-top:28px;padding-right:20px" class="form-check  flex-100">
                <input id="24houroperation" class="form-check-input checkbox-parameters" formControlName="Is24HourOperation" type="checkbox">
                <label class="form-check-label" for="24houroperation">24 Hour Operation</label>
              </div>
            </div>

            <div class="flex-column flex-33">
              <div style="padding-top:28px;padding-right:20px" class="form-check  flex-100">
                <input id="IsGateGuarded" class="form-check-input checkbox-parameters" formControlName="IsGateGuarded" type="checkbox">
                <label class="form-check-label" for="IsGateGuarded">Is Gate Guarded</label>
              </div>

              <div style="padding-top:28px;padding-right:20px" class="form-group flex-100">
                <label>Frac Type</label>
                <kendo-dropdownlist class="form-control" [style.width.%]="90" formControlName="FracType" [data]="fracTypeData" [textField]="'Description'" [valueField]="'FracTypeId'" [valuePrimitive]="true">
                </kendo-dropdownlist>
              </div>
            </div>
          </div>

          <!-- For each  Row  -->
          <div class="flex-column flex-100" style="padding:40px 0px 10px 0px">
            <h6 class="card-title">Staging and Spacing</h6>
            <div class="flex-column" style="padding-bottom:10px">

              <!-- For each Staging and Spacing Row  -->
              <div class="flex-align-row flex-100" style="padding-left:10px">
                <div class="form-group flex-25">
                  <label>Scheduled Completed LL</label>
                  <input type="text" class="k-textbox form-control" readonly value="{{stagingData?.CompleteLateralLength | safeNumber:'1.0-0'}}">
                </div>
                <div class="form-group flex-25">
                  <label>Stored Completed LL</label>
                  <input type="text" class="k-textbox form-control" readonly value="{{stagingData?.CompletedLateralLengthStored | safeNumber:'1.0-0'}}">
                </div>

                @if (showStimProject) {
                <div class="form-group flex-50">
                  <label>Treating Pressure</label>
                  <input type="text" class="k-textbox form-control" readonly value="{{stagingData?.TreatingPressure | safeNumber:'1.0-0'}}">
                </div>
                }
              </div>

              <!-- For each Staging and Spacing Row  -->
              <div class="flex-align-row flex-100" style="padding-left:10px">
                <div class="form-group flex-50">
                  <label>Stage Count</label>
                  <input type="text" class="k-textbox form-control" readonly value="{{stagingData?.StageCount | safeNumber:'1.0-0'}}">
                </div>
                <div class="form-group flex-50">
                  <label>Stage Count Override</label>
                  <input type="number" class="k-textbox form-control" formControlName="StageCountOverride">
                </div>
              </div>

              <!-- For each Staging and Spacing Row  -->
              <div class="flex-align-row flex-100" style="padding-left:10px">
                @if (showStimProject) {
                <div class="form-group flex-50">
                  <label>Pump Rate</label>
                  <input type="number" class="k-textbox form-control" readonly formControlName="PumpRate">
                </div>
                <div class="form-group flex-50">
                  <label>Pump Rate Override</label>
                  <input type="number" class="k-textbox form-control" formControlName="PumpRateOverride">
                </div>
                }
              </div>

              <!-- For each Staging and Spacing Row  -->
              <div class="flex-align-row flex-100" style="padding-left:10px">
                <div class="form-group flex-50">
                  <label>Stage Length</label>
                  <input type="text" class="k-textbox form-control" readonly value="{{stagingData?.StageLength | safeNumber:'1.0-2'}}">
                </div>
                @if (showStimProject) {
                <div class="form-group flex-50">
                  <label>Pump Time</label>
                  <input type="text" class="k-textbox form-control" readonly value="{{stagingData?.PumpTime | safeNumber:'1.0-2'}}">
                </div>
                }
              </div>

              <div class="flex-align-row flex-100" style="padding-left:10px">
                <div class="form-group flex-50">
                  <label>Clusters Per Stage</label>
                  <input type="text" class="k-textbox form-control" readonly value="{{stagingData?.ClustersPerStage | safeNumber:'1.0-0'}}">
                </div>
                <div class="form-group flex-50">
                </div>
              </div>

              <!-- For each Staging and Spacing Row  -->
              @if (showPostStimProject) {
              <div class="flex-align-row flex-100" style="padding-left:10px">
                <div class="form-group flex-50">
                  <label>Drill Out Method</label>
                  <kendo-dropdownlist class="form-control" [style.width.%]="90" formControlName="DrillOutMethod" [data]="dDrilloutMethod" [textField]="'Description'" [valueField]="'DrilloutMethodId'" [valuePrimitive]="true">
                  </kendo-dropdownlist>
                </div>
                <div class="form-group flex-50">
                  <label>Plugs per Day</label>
                  <input type="number" class="k-textbox form-control" readonly value="{{stagingData?.PlugsPerDay}}">
                </div>
              </div>
              }
            </div>
            <app-project-drilling-phase-step [iProjectId]="iProjectId()" [iProjectTypeId]="iProjectTypeId()">
            </app-project-drilling-phase-step>
          </div>
        </div>
      </div>

      <!-- Right Column -->
      <div class="flex-column flex-50">
        <div style="text-align: right;">
          <button type="button" kendoButton themeColor="primary" [buttonLoading]="loading" [svgIcon]="icons.refresh" [disabled]="loading" (click)="refreshParameters(true)">Refresh Parameters</button>
        </div>
        <!-- Begin ... Fluid Section  -->
        @if (showStimProject) {
        <app-project-completion-fluid [fluidData]="fluidData" [fluidForm]="fluidDataForm" (tooltipClick)="onClickTooltipIcon()">
        </app-project-completion-fluid>
        }
        <!-- End ... Fluid Section  -->

        <!-- Begin ...  Sand Section  -->
        @if (showStimProject) {
        <div class="flex-column flex-100">
          <h6 class="card-title">Sand</h6>
          <div class="flex-column flex-100">
            <div class="flex-row flex-100">
              <div style="padding: 0 5px 0 10px;" class="form-group flex-33">
                <label>Sand Quantity (lb/ft)</label>
                <input type="text" class="k-textbox form-control" readonly value="{{completionsObject?.ProppantPoundsPerFt | safeNumber:'1.0-0'}}">
              </div>
              <div style="padding-left:10px" class="form-group flex-33"></div>
              <div style="padding-left:10px" class="form-group flex-33"></div>
            </div>
            <div class="flex-row flex-100">
              <div class="flex-column flex-33" style="padding: 0 5px 0 10px;">
                <div class="form-group">
                  <label>Sand Type 1</label>
                  <input type="text" class="k-textbox form-control" readonly value="{{proppantType1Description}}">
                </div>
                <!-- for each Column element -->
                <div class="form-group">
                  <label>Sand Type 2</label>
                  <input type="text" class="k-textbox form-control" readonly value="{{proppantType2Description}}">
                </div>
                <!-- for each Column element -->
                <div class="form-group">
                  <label>Sand Type 3</label>
                  <input type="text" class="k-textbox form-control" readonly value="{{proppantType3Description}}">
                </div>
                <!-- for each Column element -->
                <div class="form-group">
                  <label>Sand Type 4</label>
                  <input type="text" class="k-textbox form-control" readonly value="{{proppantType4Description}}">
                </div>
              </div>
              <div class="flex-column flex-33" style="padding: 0 25px">
                <!-- for each Column element -->
                <div class="form-group">
                  <label>Percent</label>
                  <kendo-svgicon [icon]="icons.questionSolid" class="ms-1 inline-help-button" (click)="onClickTooltipIcon()"></kendo-svgicon>
                  <kendo-numerictextbox formControlName="ProppantType1Percent" class="text-right form-control" [format]="'p1'" [step]=".01" [min]="0" [max]="1" [spinners]="false" [autoCorrect]="true">
                  </kendo-numerictextbox>
                </div>
                <!-- for each Column element -->
                <div class="form-group">
                  <label>Percent</label>
                  <kendo-svgicon [icon]="icons.questionSolid" class="ms-1 inline-help-button" (click)="onClickTooltipIcon()"></kendo-svgicon>
                  <kendo-numerictextbox formControlName="ProppantType2Percent" class="text-right form-control" [format]="'p1'" [step]=".01" [min]="0" [max]="1" [spinners]="false" [autoCorrect]="true">
                  </kendo-numerictextbox>
                </div>
                <!-- for each Column element -->
                <div class="form-group">
                  <label>Percent</label>
                  <kendo-svgicon [icon]="icons.questionSolid" class="ms-1 inline-help-button" (click)="onClickTooltipIcon()"></kendo-svgicon>
                  <kendo-numerictextbox formControlName="ProppantType3Percent" class="text-right form-control" [format]="'p1'" [step]=".01" [min]="0" [max]="1" [spinners]="false" [autoCorrect]="true">
                  </kendo-numerictextbox>
                </div>
                <!-- for each Column element -->
                <div class="form-group">
                  <label>Percent</label>
                  <kendo-svgicon [icon]="icons.questionSolid" class="ms-1 inline-help-button" (click)="onClickTooltipIcon()"></kendo-svgicon>
                  <kendo-numerictextbox formControlName="ProppantType4Percent" class="text-right form-control" [format]="'p1'" [step]=".01" [min]="0" [max]="1" [spinners]="false" [autoCorrect]="true">
                  </kendo-numerictextbox>
                </div>
                <!-- Totalized % Column -->
              </div>
              <div class="flex-column flex-33" style="padding: 0 0 0 5px;">
                <!-- for each Column element -->
                <div class="form-group">
                  <label>Quantity</label>
                  <input type="text" class="k-textbox form-control" readonly value="{{completionsObject?.SandType1Total | safeNumber:'1.0-0'}}">
                </div>
                <!-- for each Column element -->
                <div class="form-group">
                  <label>Quantity</label>
                  <input type="text" class="k-textbox form-control" readonly value="{{completionsObject?.SandType2Total | safeNumber:'1.0-0'}}">
                </div>
                <!-- for each Column element -->
                <div class="form-group">
                  <label>Quantity</label>
                  <input type="text" class="k-textbox form-control" readonly value="{{completionsObject?.SandType3Total | safeNumber:'1.0-0'}}">
                </div>
                <!-- for each Column element -->
                <div class="form-group">
                  <label>Quantity</label>
                  <input type="text" class="k-textbox form-control" readonly value="{{completionsObject?.SandType4Total | safeNumber:'1.0-0'}}">
                </div>
              </div>
            </div>
          </div>
        </div>
        }
        <!-- End ...  Sand Section  -->

        <!-- Begin ...  Plat Coordinates Section  -->
        <div class="flex-column flex-100">
          <h6 class="card-title">Plat Coordinates</h6>
          <div class="flex-column flex-100">
            <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; padding-right: 20px;">
              <div class="form-group flex-25">
                <label>SHL/POP X</label>
                <kendo-numerictextbox [readonly]="true" formControlName="SurfaceHoleLocationPointOfPenetrationXCoordinate" class="form-control" [min]="-1000" [max]="20000000" [step]="5" [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>

              </div>
              <div class="form-group flex-25">
                <label>SHL/POP X Override</label>
                <kendo-numerictextbox formControlName="SurfaceHoleLocationPointOfPenetrationXCoordinateOverride" class="form-control" [min]="-1000" [max]="20000000" [step]="5" [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>

              </div>
              <div class="form-group flex-25">
                <label>SHL/POP Y</label>
                <kendo-numerictextbox class="form-control" [readonly]="true" formControlName="SurfaceHoleLocationPointOfPenetrationYCoordinate" [min]="-1000" [max]="20000000" [step]="5" [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>

              </div>
              <div class="form-group flex-25">
                <label>SHL/POP Y Override</label>
                <kendo-numerictextbox class="form-control" formControlName="SurfaceHoleLocationPointOfPenetrationYCoordinateOverride" [min]="-1000" [max]="20000000" [step]="5" [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>

              </div>
            </div>
            <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; padding-right: 20px;">
              <div class="form-group flex-25">

                <label>FTP X</label>
                <kendo-numerictextbox [readonly]="true" formControlName="FirstTakePointXCoordinate" class="form-control" [min]="-1000" [max]="20000000" [step]="5" [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
              <div class="form-group flex-25">

                <label>FTP X Override</label>
                <kendo-numerictextbox formControlName="FirstTakePointXCoordinateOverride" class="form-control" [min]="-1000" [max]="20000000" [step]="5" [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
              <div class="form-group flex-25">
                <label>FTP Y</label>
                <kendo-numerictextbox [readonly]="true" formControlName="FirstTakePointYCoordinate" class="form-control" [min]="-1000" [max]="20000000" [step]="5" [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
              <div class="form-group flex-25">
                <label>FTP Y Override</label>
                <kendo-numerictextbox formControlName="FirstTakePointYCoordinateOverride" class="form-control" [min]="-1000" [max]="20000000" [step]="5" [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
            </div>
            <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; padding-right: 20px;">
              <div class="form-group flex-25">
                <label>BHL X</label>
                <kendo-numerictextbox [readonly]="true" formControlName="BottomHoleLocationXCoordinate" class="form-control" [min]="-1000" [max]="20000000" [step]="5" [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>

              </div>
              <div class="form-group flex-25">
                <label>BHL X Override</label>
                <kendo-numerictextbox formControlName="BottomHoleLocationXCoordinateOverride" class="form-control" [min]="-1000" [max]="20000000" [step]="5" [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>

              </div>
              <div class="form-group flex-25">
                <label>BHL Y</label>
                <kendo-numerictextbox [readonly]="true" formControlName="BottomHoleLocationYCoordinate" class="form-control" [min]="-1000" [max]="20000000" [step]="5" [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
              <div class="form-group flex-25">
                <label>BHL Y Override</label>
                <kendo-numerictextbox formControlName="BottomHoleLocationYCoordinateOverride" class="form-control" [min]="-1000" [max]="20000000" [step]="5" [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
            </div>
            <div class="flex-full flex-align-start flex-gap-10" style="padding-left:10px; padding-right: 20px;">
              <div class="form-group flex-50">
                <label>Landing Point KBTVD (in feet)</label>
                <input type="text" class="k-textbox form-control" style="width: 100%" readonly value="{{completionsObject?.LandingPoint | safeNumber:'1.0-0'}}">
              </div>
              <div class="form-group flex-25">
                <label>Landing Point Override Value</label>
                <kendo-numerictextbox formControlName="LandingPointOverride" class="form-control" [min]="-1000" [max]="20000000" [step]="5" [decimals]="decimalPrecision" [spinners]="false" [format]="decimalFormat">
                </kendo-numerictextbox>
              </div>
            </div>
          </div>
        </div>
        <!-- End ...  Sand Section  -->
      </div>
    </div>
  </form>
</div>
@if (isTooltipVisible) {
<kendo-dialog class="standard-dialog" title="Note" (close)="isTooltipVisible = false" width="850">
  <div style="padding: 12px 10px;">
    <p>{{parameterTooltipLabel}}</p>
  </div>
</kendo-dialog>
}